import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sliderApi } from "../api/sliderApi";

export default function SliderList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const formatDateTime = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return "";

    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();

    const hh = String(dt.getHours()).padStart(2, "0");
    const min = String(dt.getMinutes()).padStart(2, "0");

    return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
  };

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await sliderApi.getAll();

      const sorted = (res.data || []).slice().sort((a, b) => {
        const da = a.createDate ? new Date(a.createDate).getTime() : 0;
        const db = b.createDate ? new Date(b.createDate).getTime() : 0;
        return db - da;
      });

      setItems(sorted);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Silinsin?")) return;
    try {
      await sliderApi.remove(id);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Delete failed");
    }
  };

  const wrapCell = {
    maxWidth: 420, 
    whiteSpace: "normal",
    overflowWrap: "anywhere", 
    wordBreak: "break-word",
    lineHeight: 1.35,
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <h1 className="pageTitle" style={{ margin: 0 }}>
          Slider
        </h1>
        <Link className="btn btnPrimary" to="/sliders/new">
           Yenisin yarat
        </Link>
      </div>

      <div style={{ marginTop: 14 }}>
        {loading ? (
          <div className="card">
            <div className="cardBody">Yüklənir...</div>
          </div>
        ) : err ? (
          <div className="card">
            <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
              {String(err)}
            </div>
          </div>
        ) : (
          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>#</th>
                  <th style={{ width: 420 }}>Başlıq</th>
                  <th style={{ width: 520 }}>Məzmun</th>
                  <th style={{ width: 170 }}>Yaradılma tarixi</th>
                  <th style={{ width: 160 }}>Şəkil</th>
                  <th style={{ width: 210 }}>Əməliyyat</th>
                </tr>
              </thead>

              <tbody>
                {items.map((x, index) => (
                  <tr key={x.id}>
                    <td>{index + 1}</td>

                    {/* WRAP tətbiq edildi */}
                    <td style={{ fontWeight: 800, ...wrapCell }}>
                      <div>
                        <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                        {x.titleAz ?? ""}
                      </div>
                      <div>
                        <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                        {x.titleEn ?? ""}
                      </div>
                      <div>
                        <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                        {x.titleRu ?? ""}
                      </div>
                    </td>

                    <td style={{ color: "rgba(255,255,255,.78)", ...wrapCell, maxWidth: 520 }}>
                      <div>
                        <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                        {x.descAz ?? ""}
                      </div>
                      <div>
                        <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                        {x.descEn ?? ""}
                      </div>
                      <div>
                        <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                        {x.descRu ?? ""}
                      </div>
                    </td>

                    <td style={{ whiteSpace: "nowrap", opacity: 0.9 }}>
                      {x.createDate ? (
                        formatDateTime(x.createDate)
                      ) : (
                        <span style={{ opacity: 0.6 }}>—</span>
                      )}
                    </td>

                    <td>
                      {x.hasImage ? (
                        <img
                          className="imgThumb"
                          alt="slider"
                          src={sliderApi.getImageUrl(x.id) + `?t=${Date.now()}`}
                        />
                      ) : (
                        <span className="badge badgeNo">Şəkil yoxdur</span>
                      )}
                    </td>

                    <td>
                      <div className="btnRow">
                        <Link className="btn" to={`/sliders/${x.id}/edit`}>
                          Redakte et
                        </Link>
                        <button
                          className="btn btnDanger"
                          onClick={() => onDelete(x.id)}
                        >
                          Sil
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {items.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ color: "rgba(255,255,255,.6)" }}>
                      Heç nə yoxdur.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
